import { useDispatch } from "react-redux";

import { ChatService } from "../api";
import { setDialogues } from "../redux/slices/privateChat";
import { useQuery, type UseQueryResult } from "react-query";
import { useTypedSelector } from "../redux/store";
import { type DialogueResultPaginatedResult } from "../api/generated/data-contracts";
interface Props {
  offset: number | undefined;
  limit: number | undefined;
}

export const useGetPrivateDialogues = ({
  offset,
  limit
}: Props): UseQueryResult<DialogueResultPaginatedResult, unknown> => {
  const dispatch = useDispatch();

  const userJwt = useTypedSelector((state) => state.auth.value);

  return useQuery({
    queryKey: ["getPrivateDialogues", userJwt],
    queryFn: async () => {
      const response = await ChatService.privateDialoguesList(
        {
          offset,
          limit
        },
        {
          headers: {
            Authorization: `Bearer ${userJwt}`
          }
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      dispatch(setDialogues(data.results ?? []));
    },
    refetchOnWindowFocus: false,
    enabled: !!userJwt
  });
};
